import { render, staticRenderFns } from "./safeWorkPermitVendor.vue?vue&type=template&id=7ae8af63"
import script from "./safeWorkPermitVendor.vue?vue&type=script&lang=js"
export * from "./safeWorkPermitVendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ae8af63')) {
      api.createRecord('7ae8af63', component.options)
    } else {
      api.reload('7ae8af63', component.options)
    }
    module.hot.accept("./safeWorkPermitVendor.vue?vue&type=template&id=7ae8af63", function () {
      api.rerender('7ae8af63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/swp/safeWorkPermitVendor.vue"
export default component.exports